/**
 * An exchange instrument identifier is exact data, not prose.
 *
 * Ellipsis or a mid-token wrap can turn one contract into an ambiguous label,
 * so the identifier stays atomic and remains available in full as a native
 * tooltip.
 */
type Props = {
  readonly symbol: string;
};

export function InstrumentSymbol({ symbol }: Props): React.JSX.Element {
  return (
    <span
      data-instrument-symbol={symbol}
      className="block whitespace-nowrap font-mono text-body-main leading-tight text-text-primary"
      title={symbol}
    >
      {symbol}
    </span>
  );
}
